<h2 mat-dialog-title *ngIf="title">{{ title }}</h2>
<mat-dialog-content *ngIf="message"
  ><p [innerHTML]="message"></p
></mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>OK</button>
</mat-dialog-actions>
